var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame250(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 31,
    viewBox: "0 0 132 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.8333V25.45L11.6667 21.8833L3.33333 25.45V3.83333H13.3333V0.5H3.33333C1.5 0.5 0 2 0 3.83333V30.5L11.6667 25.5L23.3333 30.5V13.8333H20ZM26.6667 7.16667H23.3333V10.5H20V7.16667H16.6667V3.83333H20V0.5H23.3333V3.83333H26.6667V7.16667Z",
    fill: "#396F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.667 14.5C42.1147 14.5 41.667 14.9477 41.667 15.5C41.667 16.0523 42.1147 16.5 42.667 16.5V14.5ZM93.3741 16.2071C93.7646 15.8166 93.7646 15.1834 93.3741 14.7929L87.0101 8.42893C86.6196 8.03841 85.9865 8.03841 85.5959 8.42893C85.2054 8.81946 85.2054 9.45262 85.5959 9.84315L91.2528 15.5L85.5959 21.1569C85.2054 21.5474 85.2054 22.1805 85.5959 22.5711C85.9865 22.9616 86.6196 22.9616 87.0101 22.5711L93.3741 16.2071ZM42.667 16.5H92.667V14.5H42.667V16.5Z",
    fill: "#396F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.667 0.5H112C110.167 0.5 108.667 2 108.667 3.83333V30.5L120.334 25.5L132 30.5V3.83333C132 2 130.5 0.5 128.667 0.5Z",
    fill: "#396F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame250);
export default __webpack_public_path__ + "static/media/Frame 250.aac2562e1773dd515ff8bf5d03e3642d.svg";
export { ForwardRef as ReactComponent };